import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs'; // Importamos Subscription
import { StaticData } from '../../../helpers/static-data'; 

@Component({
  selector: 'app-header-pqrs',
  templateUrl: './header-pqrs.component.html',
  styleUrls: ['./header-pqrs.component.scss'],
  encapsulation: ViewEncapsulation.None 
})
export class HeaderPqrsComponent implements OnInit, OnDestroy {
  mostrarHeader = false;
  safeHtml: SafeHtml;
  private configSub: Subscription; // Guardamos la suscripción

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    // 1. Intento inicial por si la data ya llegó súper rápido
    this.cargarHtml();

    // 2. Nos suscribimos al "timbre" para cuando la data llegue de la API
    this.configSub = StaticData.onConfigUpdated.subscribe(() => {
      this.cargarHtml();
    });
  }

  // Limpiamos la memoria cuando el componente muere
  ngOnDestroy() {
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }

  // Separamos la lógica para poder llamarla varias veces
  private cargarHtml() {
    // Validación clásica compatible con Angular 8
    let htmlHeader = null;
    if (StaticData.GeneralConfig && StaticData.GeneralConfig.ConfigUI) {
      htmlHeader = StaticData.GeneralConfig.ConfigUI.HeaderPortalRadicacion;
    }
    
    if (htmlHeader && htmlHeader.trim() !== '') {
      this.mostrarHeader = true;
      this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(htmlHeader);
      console.warn('¡Header HTML cargado exitosamente!');
    } else {
      this.mostrarHeader = false; 
    }
  }
}